// import React, { useEffect, useState } from 'react';
// import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap';
// import { Typewriter } from 'react-simple-typewriter';
// import '../../styles/login.scss';
// import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { loginUser } from '../../redux/slices/authSlice';
// import { toast } from 'react-toastify';
// import Logo from '../../assets/logo7.png';
// import { messaging } from '../../firebase'; // adjust the path
// import { getToken } from 'firebase/messaging';
// import { serverUrlAuth } from '../../serverUrl';

// const Login = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//   });
//   const { loading } = useSelector((state) => state.auth);

//   // Handle input field changes
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const requestNotificationPermission = async () => {
//     try {
//       const permission = await Notification.requestPermission();
//       if (permission !== 'granted') return;

//       // const token = await getToken(messaging, {
//       //   vapidKey:
//       //     'BPJeaJai7hMaSndqhkJBlQd8c7tfhMQwOhpziJxZQVzREPG4u70ntQpw_syUXoRT6AHmge8bEb4IaiXbkaMADzc',
//       // });
//       const token = await getToken(messaging, {
//         vapidKey:
//           'BPJeaJai7hMaSndqhkJBlQd8c7tfhMQwOhpziJxZQVzREPG4u70ntQpw_syUXoRT6AHmge8bEb4IaiXbkaMADzc',
//         serviceWorkerRegistration: window.fcmServiceWorker, // use SW from index.js
//       });

//       // if (token) {
//       //   await serverUrlAuth.post('/notifications/save-push-token/', { token });
//       //   console.log('Push token saved:', token);
//       //   localStorage.setItem('fcm_token', token);
//       // }

//       if (token) {
//         localStorage.setItem('fcm_token', token);

//         await serverUrlAuth.post('/notifications/save-push-token/', {
//           token,
//         });

//         console.log('Push token saved:', token);
//       }
//     } catch (err) {
//       console.error('Error getting push token:', err);
//     }
//   };

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     dispatch(loginUser(formData))
//       .unwrap()
//       .then((response) => {
//         toast.success('Login successful! Welcome back.');

//         // Save auth info in localStorage (if not already handled in slice)
//         localStorage.setItem('access_token', response.access);
//         localStorage.setItem('refresh_token', response.refresh);
//         localStorage.setItem('role', response.role);
//         localStorage.setItem('full_name', response.full_name);

//         // Request notification permission and save push token
//         requestNotificationPermission();

//         // Redirect based on role
//         const redirectPath =
//           response.role === 'artisan'
//             ? '/artisan-dashboard'
//             : response.role === 'admin'
//               ? '/admin-dashboard'
//               : '/mode-selection';

//         // Give toast 2 seconds to show before redirect
//         setTimeout(() => navigate(redirectPath), 2000);
//       })
//       .catch((err) => {
//         toast.error(
//           err?.non_field_errors?.[0] ||
//             'Login failed. Please check your credentials.',
//         );
//         setFormData({ ...formData, password: '' });
//       });
//   };

//   useEffect(() => {
//     const token = localStorage.getItem('access_token');
//     const role = localStorage.getItem('role');

//     if (token && role) {
//       // User is already logged in → redirect based on role
//       const redirectPath =
//         role === 'artisan' ? '/artisan-dashboard' : '/client-dashboard';
//       navigate(redirectPath);
//     }
//   }, [navigate]);

//   return (
//     <Row className="login-row">
//       {/* Left Side */}
//       <Col md={6} className="login-left">
//         <div className="overlay"></div>
//         <div className="login-left-content">
//           <Link to="/">
//             <img src={Logo} alt="Artiza Logo" className="logo" />
//           </Link>
//           <h2 className="typing-text">
//             <Typewriter
//               words={[
//                 'Discover amazing art.',
//                 'Connect with artists worldwide.',
//                 'Join our creative community.',
//               ]}
//               loop={true}
//               cursor
//               cursorStyle="_"
//               typeSpeed={70}
//               deleteSpeed={50}
//               delaySpeed={1500}
//             />
//           </h2>
//         </div>
//       </Col>

//       {/* Right Side: Login Form */}
//       <Col md={6} className="login-right">
//         <div className="login-form-container">
//           <h2>Login</h2>
//           <Form onSubmit={handleSubmit}>
//             {/* Email */}
//             <Form.Group className="mb-4" controlId="formBasicEmail">
//               <Form.Label>Email address</Form.Label>
//               <Form.Control
//                 type="email"
//                 placeholder="Enter email"
//                 className="form-input"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </Form.Group>

//             {/* Password */}
//             <Form.Group className="mb-2" controlId="formBasicPassword">
//               <Form.Label>Password</Form.Label>
//               <InputGroup>
//                 <Form.Control
//                   type={showPassword ? 'text' : 'password'}
//                   placeholder="Password"
//                   className="form-input"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   required
//                 />
//                 <Button
//                   variant="outline-secondary"
//                   onClick={() => setShowPassword(!showPassword)}
//                 >
//                   {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
//                 </Button>
//               </InputGroup>
//               <div className="text-end mt-2">
//                 <Link to="/forgot-password" className="forgot-password-link">
//                   Forgot Password?
//                 </Link>
//               </div>
//             </Form.Group>

//             {/* Submit */}
//             <Button type="submit" className="w-100 login-btn mb-3">
//               {loading ? 'Logging In...' : 'Log In'}
//             </Button>

//             <div className="text-center">
//               <span>Don't have an account? </span>
//               <Link to="/register" className="create-account-link">
//                 Create new account
//               </Link>
//             </div>
//           </Form>
//         </div>
//       </Col>
//     </Row>
//   );
// };

// export default Login;



// Login.jsx
import React, { useEffect, useState } from 'react';
import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap';
import { Typewriter } from 'react-simple-typewriter';
import '../../styles/login.scss';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loginUser } from '../../redux/slices/authSlice';
import { toast } from 'react-toastify';
import Logo from '../../assets/logo7.png';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const { loading } = useSelector((state) => state.auth);

  // Handle input field changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission - Only handles authentication, no token saving
  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(loginUser(formData))
      .unwrap()
      .then((response) => {
        // OTP is always required
        if (response.otp_required) {
          toast.info('A verification code has been sent to your email.');
          
          // Navigate to OTP verification page with challenge_id and email
          navigate('/OTP-verification', {
            state: {
              challenge_id: response.challenge_id,
              email: response.email
            }
          });
        }
      })
      .catch((err) => {
        // Handle different error formats
        const errorMessage = 
          err?.error || 
          err?.non_field_errors?.[0] || 
          err?.message ||
          'Login failed. Please check your credentials.';
        toast.error(errorMessage);
        setFormData({ ...formData, password: '' });
      });
  };

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');

    if (token && role) {
      // User is already logged in → redirect based on role
      const redirectPath =
        role === 'artisan' ? '/artisan-dashboard' : 
        role === 'admin' ? '/admin-dashboard' : 
        '/client-dashboard';
      navigate(redirectPath);
    }
  }, [navigate]);

  return (
    <Row className="login-row">
      {/* Left Side */}
      <Col md={6} className="login-left">
        <div className="overlay"></div>
        <div className="login-left-content">
          <Link to="/">
            <img src={Logo} alt="Artiza Logo" className="logo" />
          </Link>
          <h2 className="typing-text">
            <Typewriter
              words={[
                'Discover amazing art.',
                'Connect with artists worldwide.',
                'Join our creative community.',
              ]}
              loop={true}
              cursor
              cursorStyle="_"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1500}
            />
          </h2>
        </div>
      </Col>

      {/* Right Side: Login Form */}
      <Col md={6} className="login-right">
        <div className="login-form-container">
          <h2>Login</h2>
          <Form onSubmit={handleSubmit}>
            {/* Email */}
            <Form.Group className="mb-4" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                className="form-input"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            {/* Password */}
            <Form.Group className="mb-2" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  className="form-input"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                </Button>
              </InputGroup>
              <div className="text-end mt-2">
                <Link to="/forgot-password" className="forgot-password-link">
                  Forgot Password?
                </Link>
              </div>
            </Form.Group>

            {/* Submit */}
            <Button type="submit" className="w-100 login-btn mb-3" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Logging In...
                </>
              ) : (
                'Log In'
              )}
            </Button>

            <div className="text-center">
              <span>Don't have an account? </span>
              <Link to="/register" className="create-account-link">
                Create new account
              </Link>
            </div>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default Login;